<!--
  Default Datepicker
    props:
      - initialDate: Array || String
      - interval: String 
      - range: String 

    !!IMPORTANT: interval prop is the only responsible for triggering the main functions of the component.
    interval prop can currently take on the following values:
      - hourly, daily, weekly, monthly, yearly

    Future implementations:
      - specific visual for yearly format
-->
<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y width="500">
    <template v-slot:activator="{ on, attrs }">
      <span v-on="on" v-bind="attrs">
        <slot></slot>
      </span>
    </template>
    <v-card>
      <component
        :is="selectedComponent"
        no-title
        v-model="chosenConfig.selectedDate"
        v-bind="chosenConfig"
      />
      <v-card-actions>
        <v-btn text color="grayLight" @click="menu = false">Cancelar</v-btn>
        <v-spacer />
        <v-btn
          elevation="0"
          :color="color"
          class="white--text"
          @click="selectDate"
          >OK</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import DatePickerMonthly from "./DatePicker.vue";
import DatePickerDaily from "./DatePicker.vue";
import DatePickerYearly from "./Pickers/DatePickerYearly.vue";
import DatePickerHourly from "./Pickers/DatePickerHourly.vue";
import Controller from "./Controller.js";
import DatePickerConfig from "./DatePickerConfig.js";

export default {
  data: () => ({
    menu: false,
    controller: new Controller(),
    hourlyConfig: new DatePickerConfig(),
    dailyConfig: new DatePickerConfig(),
    dailyRangeConfig: new DatePickerConfig(),
    weeklyConfig: new DatePickerConfig(),
    weeklyRangeConfig: new DatePickerConfig(),
    monthlyConfig: new DatePickerConfig(),
    monthlyRangeConfig: new DatePickerConfig(),
    chosenConfig: new DatePickerConfig(),
    selectedComponent: "DatePickerMonthly",
  }),
  components: {
    DatePickerHourly,
    DatePickerDaily,
    DatePickerMonthly,
    DatePickerYearly,
  },
  props: {
    date: [String, Array],
    initialDate: [String, Array],
    interval: {
      type: String,
      default: "daily",
    },
    max: {
      type: [String, Object],
    },
    min: {
      type: [String, Object],
    },
    color: {
      type: String,
      default: "green lighten-1",
    },
    closeOnClick: {
      type: Boolean,
      default: true,
    },
    range: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // initialDate: {
    //   handler() {
    //     this.setInitialDate();
    //   },
    //   deep: true,
    // },
    interval: {
      handler() {
        this.start();
      },
      deep: true,
    },
    // range: {
    //   handler() {
    //     this.chosenConfig.range = this.range;
    //     this.start();
    //   },
    // },
    chosenConfig: {
      handler() {
        this.setMaxMin();
      },
      deep: true,
    },
  },
  created() {
    this.start();
  },
  methods: {
    start() {
      if (!this.interval) return;
      this.selectConfig();
      this.selectComponent();
      this.setInitialDate();
      this.selectDate();
      this.setMaxMin();
    },
    setInitialDate() {
      // if (!this.chosenConfig.selectedDate || !this.chosenConfig.selectedDate.length)
      this.chosenConfig.selectedDate = this.controller.initialValue(
        this.chosenConfig.initialDate,
        this.interval,
        this.chosenConfig.range
      );
    },
    setMaxMin() {
      this.chosenConfig.max = this.controller.setMax(
        this.chosenConfig.selectedDate,
        this.max,
        this.interval,
        this.chosenConfig.range
      );
      this.chosenConfig.min = this.controller.setMin(
        this.chosenConfig.selectedDate,
        this.min,
        this.interval,
        this.chosenConfig.range
      );
    },
    selectConfig() {
      switch (this.interval) {
        case "hourly":
          this.chosenConfig = this.hourlyConfig;
          break;
        case "daily":
          this.chosenConfig = this.range
            ? this.dailyRangeConfig
            : this.dailyConfig;
          break;
        case "weekly":
          this.chosenConfig = this.range
            ? this.weeklyRangeConfig
            : this.weeklyConfig;
          break;
        case "monthly":
          this.chosenConfig = this.range
            ? this.monthlyRangeConfig
            : this.monthlyConfig;
          break;
        case "yearly":
          this.chosenConfig = this.range
            ? this.monthlyRangeConfig
            : this.monthlyConfig;
          break;
        default:
          this.chosenConfig = this.range
            ? this.dailyRangeConfig
            : this.dailyConfig;
      }
      this.chosenConfig.mountData({
        initialDate: this.initialDate,
        color: this.color,
        type: this.controller.setType(this.interval),
        range: this.range,
      });
    },
    selectComponent() {
      switch (this.interval) {
        case "hourly":
          this.selectedComponent = this.range
            ? "DatePickerHourly"
            : "DatePickerDaily";
          break;
        case "daily":
          this.selectedComponent = "DatePickerDaily";
          break;
        case "weekly":
          this.selectedComponent = "DatePickerDaily";
          break;
        case "monthly":
          this.selectedComponent = "DatePickerMonthly";
          break;
        case "yearly":
          this.selectedComponent = "DatePickerYearly";
          break;
        default:
          this.selectedComponent = "DatePickerDaily";
      }
    },
    selectDate() {
      let date = this.controller.setDate(
        this.chosenConfig.selectedDate,
        this.interval,
        this.chosenConfig.range
      );
      if (!date) return;
      let response = this.controller.mountResponse(
        date.start,
        date.end,
        this.interval,
        this.chosenConfig.range
      );
      this.$emit("input", response);
      if (this.closeOnClick) {
        this.menu = false;
      }
    },
  },
};
</script>

<style></style>
